import React, { memo } from 'react';
import { MEDWIKI_DEMO, reactHtmlParser, specialityPopOver } from '../../../common/common';
import useRedirect from '../../customHooks/useRedirect';
import LazyImage from '../../CustomLibraries/LazyImage';
import { FiShare2 } from '../../icons';
import ShareCard from '../../ShareCard';
import './css/_medwikiCardV2.scss';

function MedwikiCardV2({
  id,
  url,
  title,
  specialities,
  specialities_ids_and_names,
  image,
  gtmTagVariable = ''
}) {
  const { redirectTo } = useRedirect();
  const click = () => redirectTo('MedwikiDetails', id, title);
  const specialityClick = () => {
    if (specialities_ids_and_names?.length > 0) {
      let { id, name } = specialities_ids_and_names[0];
      redirectTo('Speciality', id, name);
    }
  };
  return (
    <div className="w-100 medWikiCardV2Box bg-white shadow rounded-3 position-relative p-3 p-md-4">
      <ShareCard
        customClass={`fs-2 text-black text-black shareBtn position-absolute ${gtmTagVariable}_medwikiCardV2_share`}
        data={{ title, url }}
      />
      <div className="d-flex justify-content-between align-items-center cursorPointer">
        <div className="medwikiPic rounded overflow-hidden me-3 me-md-4" onClick={click}>
          <LazyImage
            src={image}
            alt="Medwiki img"
            className={`object-fit-cover w-100 h-100 float-start position-absolute top-0 start-0 ${gtmTagVariable}_medwikiCardV2`}
            fallback_image={MEDWIKI_DEMO}
          />
        </div>
        <div className="medwikiDetails text-start flex-1 ">
          {specialities_ids_and_names && specialities_ids_and_names.length > 0 && (
            <h6
              className={`fs-4 fw-light text-dark speciality mb-1 ${gtmTagVariable}_medwikiCardV2_speciality d-flex align-items-center`}
            >
              <span
                className={`${gtmTagVariable}_medwikiCardV2_speciality`}
                onClick={specialityClick}
              >
                {specialities_ids_and_names[0].name}
              </span>
              {specialityPopOver(
                specialities_ids_and_names.map((speciality) => speciality.name).join(',')
              )}
            </h6>
          )}
          <h4
            className={`fs-16 fw-medium text-black line-clamp-2 ${gtmTagVariable}_medwikiCardV2`}
            onClick={click}
          >
            {reactHtmlParser(title)}
          </h4>
        </div>
      </div>
    </div>
  );
}
export default memo(MedwikiCardV2);
